/*
 * Copyright (c) Nexign, JSC, 2019-2024.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Alexander Golshtein
 * @author Ilya Baranchikov
 * @version 1.30.0
 * @since 1.0.0
 */
import { icons } from '../assets';

// type of action files
export type HistoryOrderActionFilesType = 'PDF' | 'HTML' | 'JPG' | 'XLS' | 'XLSX' | 'CSV' | 'TXT' | 'RTF' | 'DEFAULT';
// typeof action id's from server
export type HistoryOrderActionFilesIdType = 1 | 2 | 3 | 4 | 5;
// map each file to icon
export const HistoryOrderActionFilesIcon: { [K in HistoryOrderActionFilesType]: string } = {
    CSV: icons.csvIcon,
    DEFAULT: icons.defaultFileIcon,
    HTML: icons.htmlIcon,
    JPG: icons.jpgIcon,
    PDF: icons.pdfIcon,
    TXT: icons.txtIcon,
    XLS: icons.fileXlsIcon,
    XLSX: icons.fileXlsxIcon,
    RTF: icons.rtfIcon,
};
